import { keyframes } from 'styled-components';

const defaultLightBackground = '#f5fee8';
const defaultBorderColor = '#000';
const defaultBorder = `2px solid ${defaultBorderColor}`;
const defaultShadow = `3px 3px 0px ${defaultBorderColor}`;

const theme = {
  staticDir: '/',

  appear: keyframes`
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  `,
  breakpoints: {
    smallHeight: '@media screen and (min-height: 600px)',
    mediumHeight: '@media screen and (min-height: 800px)',
    largeHeight: '@media screen and (min-height: 900px)',
    mediumWidth: '@media screen and (min-width: 1000px)',
  },
  text: {
    color: '#000',
  },
  modal: {
    background: defaultLightBackground,
    border: defaultBorder,
    shadow: defaultShadow,
    radius: '15px',
  },
  minimap: {
    background: 'transparent',
    border: defaultBorder,
    shadow: defaultShadow,
    radius: '15px',
  },
  button: {
    background: defaultLightBackground,
    border: defaultBorder,
    shadow: defaultShadow,
    radius: '15px',
  },
  lockedButton: {
    background: 'rgba(100, 100, 100, 0.4)',
    border: `2px dashed ${defaultBorderColor}`,
    shadow: defaultShadow,
    radius: '15px',
  },
  table: {
    border: '1px solid #dee2e6',
  },
  enemy: {
    Octo1: '#f9ad80',
    Octo2: '#f16c4f',
    Octo3: '#ed1c24',
  },
};

export default theme;
